<template>
	<div class="app-footer">
		<v-layout class="container" wrap justify-center>
			<v-flex xs12 md6 class="wrapper-logos">
				<v-layout wrap>
					<v-flex xs12 mb-3>
						<h2 class="w-black title-footer pa-16-desktop" v-if="!isJapi">CASA MARKET llega gracias a Apprunn</h2>
						<h2 class="w-black title-footer pa-16-desktop" v-else>JAPISALE llega gracias a Apprunn</h2>
					</v-flex>
					<v-flex xs12>
						<p class="w-black pa-16-desktop">Nuestros productos y  principales clientes/partnes:</p>
					</v-flex>
					<v-layout wrap class="pa-20-desktop">
						<v-flex xs6 pa-2>
							<a href="https://feedbackinn.com/" target="_blank">
								<img 
									src="/static/images-new/logos/logo-feedbackinn.png" 
									alt="feedbackinn"
									height="28">
							</a>
						</v-flex>
						<v-flex xs6 pa-2>
							<a href="https://makipos.la/" target="_blank">
								<img 
									src="/static/images-new/logos/logo-makipos.png" 
									alt="makipos"
									height="28">
							</a>
						</v-flex>
						<v-flex class="text-right" pa-2 :class="[isJapi ? 'xs6' : 'xs4']">
							<a href="https://fenixcorp.net/" target="_blank">
								<img 
									src="/static/images-new/logos/logo-fenix.png" 
									alt="fenix"
									height="28">
							</a>
						</v-flex>
						<v-flex xs4 pa-2 class="text-right" v-if="!isJapi">
							<a href="https://japisale.com/" target="_blank">
								<img 
									src="/static/images-new/logos/logo-japisale.png" 
									alt="japisale"
									height="28">
							</a>
						</v-flex>
						<v-flex pa-2 class="text-right" :class="[isJapi ? 'xs6' : 'xs4']">
							<a href="https://casamarket.la/" target="_blank" v-if="isJapi">
								<img 
									src="/static/images-new/logos/casa-market.svg" 
									alt="praktiko"
									height="28">
							</a>
							<img
								v-else
								src="/static/images-new/logos/logo-praktiko.png" 
								alt="praktiko"
								height="28">	
						</v-flex>	
					</v-layout>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="wrapper-text">
				<p>Apprun es un Product Studio que tiene como misión 
					crear productos que ayuden a mejorar la vida de la gente .
				</p>
				<v-flex xs12 mt-5 pl-2 class="btn-desktop">
					<a
						:href="linkAppRunn"
						target="_blank"
						:class="[isJapi ? 'btn-blue' : 'btn-green']"
						class="btn-link">Visita Apprunn.com</a>
				</v-flex>
			</v-flex>
			<v-flex xs12 mt-3 class="btn-mobile" text-xs-center>
				<a
					:href="linkAppRunn"
					target="_blank"
					:class="[isJapi ? 'btn-blue' : 'btn-green']"
					class="btn-link">Visita Apprunn.com</a>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>

function data() {
	return {
		linkAppRunn: process.env.LINK_APPRUNN,
	};
}

export default {
	name: 'app-footer',
	data,
	props: {
		isJapi: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.app-footer {
		background: color(newwarning);
		color: color(white);
		line-height: 24px;
		padding: 70px 5%;

		@media (max-width: 900px) {
			padding: 30px 3%;
		}

		img {
			max-width: 100%;
		}
	}

	.text-right {
		text-align: right;
	}

	.title-footer {
		font-size: size(large);
		line-height: 30px;
		text-transform: uppercase;

		@media (max-width: 900px) {
			text-align: center;
		}
	}

	.pa-16-desktop {
		padding: 0 16px;
	}

	.wrapper-text {
		font-size: size(medium16);
	}

	.btn-link {
		border-radius: 8px;
		color: color(white);
		display: inline-block;
		padding: 15px 60px;
		text-align: center;
		text-decoration: none;
		text-transform: uppercase;
		width: 100%;
	}

	.btn-blue {
		background-color: color(blue-japi);
	}

	.btn-green {
		background-color: color(primary);
	}

	.btn-mobile {
		display: none;

		@media (max-width: 900px) {
			display: block;
		}
	}

	.btn-desktop {
		@media (max-width: 900px) {
			display: none;
		}
	}

	.wrapper-logos {
		@media (max-width: 900px) {
			margin-bottom: 45px;
		}
	}

	.pa-20-desktop {
		padding-right: 20%;

		@media (max-width: 900px) {
			padding-right: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home-new/app-footer.vue